import * as React from 'react';
import { withStyles } from '@material-ui/core/styles';
var styles = {
  label: {
    cursor: 'pointer'
  }
};

var TextIcon = function TextIcon(props) {
  var children;
  var index = props.index,
      rowData = props.rowData;

  var iconClickHandler = function iconClickHandler() {
    if (props.onIconClick && typeof props.onIconClick === 'function') {
      props.onIconClick({
        index: index,
        rowData: rowData
      });
    }
  };

  var getIconDiv = function getIconDiv(iconObj) {
    return iconObj != null && React.createElement("div", {
      onClick: function onClick() {
        return iconClickHandler();
      },
      className: "".concat(props.classes.label)
    }, iconObj);
  };

  var content = typeof props.children === 'string' ? props.children : '';
  var defaultToPostfix = !props.prefix && !props.postfix;
  var iconComponent = props.icon ? typeof props.icon === 'function' ? props.icon({
    index: index,
    rowData: rowData
  }) : typeof props.icon === 'object' ? props.icon : null : null;
  return React.createElement("div", {
    style: {
      display: 'flex',
      flexDirection: 'row'
    },
    "data-testid": "texticon-div"
  }, props.prefix && getIconDiv(iconComponent), React.createElement("div", null, React.createElement("label", {
    className: "".concat(props.classes.label),
    title: content,
    "data-test": props.testClass,
    style: {
      paddingRight: 10
    },
    "data-testid": "textLabel"
  }, content)), (defaultToPostfix || props.postfix) && getIconDiv(iconComponent));
};

export default withStyles(styles)(TextIcon);